import styled from "styled-components";
import { Typography } from "@material-ui/core";

const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 215px) minmax(auto, 215px) auto 1fr;
  gap: ${props => props.theme.spacing(1, 3)};
  margin-bottom: ${props => props.theme.spacing(3)}px;

  .identificationNumber {
    grid-area: 2/1;
  }
  .taxIdentificationNumber {
    grid-area: 2/2;
  }

  .error-identificationNumber {
    grid-area: 2/3;
  }

  .error-taxIdentificationNumber {
    grid-area: 2/4;
  }

  .street {
    grid-area: 3/1;
  }
  .streetNo {
    grid-area: 3/2;
  }

  .error-street {
    grid-area: 3/3;
  }

  .error-streetNo {
    grid-area: 3/4;
  }
  .city {
    grid-area: 4/1;
  }

  .postalCode {
    grid-area: 4/2;
  }

  .error-city {
    grid-area: 4/3;
  }

  .error-postalCode {
    grid-area: 4/4;
  }

  .cooperationDueDate {
    grid-area: 5/1;
  }
  .error-cooperationDueDate {
    grid-area: 5/2;
  }
  @media (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
    gap: ${props => props.theme.spacing(1, 3)};

    .identificationNumber {
      grid-area: 2/1;
    }
    .taxIdentificationNumber {
      grid-area: 2/2;
    }

    .error-identificationNumber {
      grid-area: 2/3;
    }

    .error-taxIdentificationNumber {
      grid-area: 2/4;
    }

    .street {
      grid-area: 3/1;
    }
    .streetNo {
      grid-area: 3/2;
    }

    .error-street {
      grid-area: 3/3;
    }

    .error-streetNo {
      grid-area: 3/4;
    }
    .city {
      grid-area: 4/1;
    }

    .postalCode {
      grid-area: 4/2;
    }

    .error-city {
      grid-area: 4/3;
    }

    .error-postalCode {
      grid-area: 4/4;
    }
  }

  ${props => props.theme.breakpoints.down("xs")} {
    grid-template-columns: 1fr;
    gap: ${props => props.theme.spacing(0, 3)};

    & > div {
      grid-area: auto !important;
      margin-bottom: ${props => props.theme.spacing(2)}px;
    }
  }
`;

const StyledRow = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 454px) auto 1fr;
  gap: 8px 24px;
`;

const StyledError = styled.div`
  color: ${props => props.theme.colors.red};
  align-self: flex-end;
  padding-bottom: ${props => props.theme.spacing(1)}px;
  font-style: italic;
  display: flex;

  @media (max-width: 1000px) {
    padding: 0;
    position: relative;
    & > * {
      font-size: 12px;
      position: absolute;
      left: 0;
      top: -8px;
    }
  }

  ${props => props.theme.breakpoints.down("xs")} {
    margin: 0 !important;
    & > * {
      top: -17px;
    }
  }
`;

const StyledLabel = styled(Typography)`
  color: ${props => props.theme.palette.secondary.main};
`;

export { StyledError, StyledLabel, StyledWrapper, StyledRow };
